<template>
  <div class="chain">
    <div class="chainItem" :style="$store.getters.authUser.identityAuth > -1 ? 'margin: 0 auto;' : 'margin: 0 auto;height: 90%'">
      <div style="display: flex;align-items: center">
        <div class="black"></div>
        <span>保全链节点查询</span>
      </div>
      <div class="item">
        <div class="it">
          <p>赣国仲裁委</p>
          <a href="http://iacg.aihuz.com" target="_blank">点击查询</a>
        </div>
        <div class="it">
          <p>深汕仲裁委</p>
          <a href="http://swzcw.aihuz.com" target="_blank">点击查询</a>
        </div>
        <div class="it">
          <p>十堰仲裁委</p>
          <a href="http://syac.aihuz.com" target="_blank">点击查询</a>
        </div>
        <div class="it">
          <p>太原城南公证处</p>
          <a href="http://cngzc.sfj.taiyuan.gov.cn/web/index.html#/chain" target="_blank">点击查询</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "securityChain"
    }
</script>

<style scoped lang="less">
  .chain {
    width: 100%;
    height: 450px;
    background: #ffffff;

    .chainItem {
      width: 1200px;
      height: 100%;
      padding-top: 70px;

      .black {
        display: inline-block;
        width: 7px;
        height: 20px;
        background: #290202;
        margin-right: 10px;
      }
      span {
        font-size: 20px;
        font-weight: bold;
        color: #290202;
      }
      .item {
        width: 100%;
        height: 195px;
        margin-top: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .it {
          width: 200px;
          height: 100%;
          background: url("../../static/images/blockChain/frame.png") no-repeat;
          background-size: cover;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;

          p {
            font-size: 18px;
            color: #EC1C1C;
            margin-top: 64px;
          }
          a {
            display: block;
            width: 126px;
            height: 41px;
            line-height: 40px;
            text-align: center;
            background: #Ec1C1C;
            font-size: 14px;
            color: #ffffff;
            position: absolute;
            bottom: 12px;
            left: 38px;
            border-radius: 20px;
          }
          a:hover {
            background: rgba(255,255,255,0.4);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/blockChain/securityChain.vue